import React, { useEffect } from "react";
import { Modal } from "@mui/material";
import TickIcon from "../../../assets/check.png";
import './ClinicAppointments.scss'
// import "./rx.scss";

const ClinicShareReceiptModal = (props) => {
  const { show, handleClose } = props;

  return (
    <div>
      {show && (
        <Modal
          open={show}
        >
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className="clinic-share-receipt-modal-wrapper">
            <div className="p-lg-5 p-2 text-center">
              <img src={TickIcon} alt="" />
              <h3 className="mt-4">Receipt Shared Successfully!</h3>
            </div>
          </div>
        </div>
        </Modal>
      )}
    </div>
  );
};

export default ClinicShareReceiptModal;
